import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, User } from 'lucide-react';
import { BlogPost } from '@/types/blog';

interface BlogCardProps {
  post: BlogPost;
  index: number;
}

export const BlogCard: React.FC<BlogCardProps> = ({ post, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      className="group bg-white border border-zinc-100 rounded-3xl p-8 hover:shadow-xl transition-all duration-500 flex flex-col h-full"
    >
      <div className="flex items-center gap-4 mb-6 text-xs font-semibold">
        <span className="text-zinc-600">
          {post.category}
        </span>
        <span className="text-zinc-300 flex items-center gap-1.5">
          <Clock className="w-3.5 h-3.5" /> {post.readTime}
        </span>
      </div>
      
      <h3 className="text-xl font-bold text-black mb-4 leading-tight">
        {post.title}
      </h3>
      
      <p className="text-zinc-500 text-sm leading-relaxed mb-8 flex-grow">
        {post.description}
      </p>

      <div className="pt-6 border-t border-zinc-50 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-xl bg-zinc-100 flex items-center justify-center">
            <User className="w-4 h-4 text-zinc-400" />
          </div>
          <div>
            <p className="text-xs font-bold text-black">{post.author.name}</p>
            <p className="text-[10px] text-zinc-400">{post.author.role}</p>
          </div>
        </div>

        <Link
          to={`/blog/${post.slug}`}
          className="bg-cyan-600 text-white w-10 h-10 rounded-full flex items-center justify-center hover:scale-110 transition-transform shadow-lg shadow-cyan-600/20"
        >
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </motion.div>
  );
};
